export { getAvailableDepartmentNames } from "./getAvailableDepartmentNames";
export { getAvailableLocationNames } from "./getAvailableLocationNames";
export { getDepartmentJobs } from "./getDepartmentJobs";
export { mergeSortDepartments } from "./mergeSortDepartments/mergeSortDepartments";
